// Utilidades para los selectores de Cohorte.
//
// CONTEXTO IMPORTANTE
// -------------------
// La cohorte NO se guarda como clave foránea. `informacion_inscripcion.cohorte`,
// `costo_curso.cohorte`, `insc_iniciativa.cohorte` y `promocion.cohorte` guardan
// el TEXTO copiado de `cohorte.descripcion` (ver SelectComponent, que usa
// insertValueField="descripcion").
//
// Consecuencia: una pantalla de EDICIÓN jamás puede quedarse sin la opción que
// tiene guardada. Si el <Form.Select> no encuentra su `value` entre las
// <option>, se muestra vacío y AL GUARDAR BORRA EL DATO HISTÓRICO.
// Por eso hay dos funciones distintas: una para altas y otra para ediciones.
//
// Antes existía `cohortesDelAnioActual`, que filtraba por el año contenido en el
// nombre (`descripcion.includes(new Date().getFullYear())`). Se eliminó: al
// cambiar de año escondía las cohortes del año anterior en las que todavía se
// estaba inscribiendo gente, y dejaba fuera para siempre a las cohortes sin año
// en el nombre. Ahora lo decide el campo `activo`, que gestiona una persona
// desde la pantalla de Cohortes.

const texto = (v) => String(v ?? '').trim();

/**
 * Cohortes ABIERTAS para inscripción. Para formularios de ALTA.
 *
 * Se compara con `activo !== false` y no con `activo === true` a propósito:
 * durante un despliegue parcial el backend todavía puede no enviar el campo, y
 * en ese caso no se debe ocultar nada.
 */
export const cohortesActivas = (cohortes) =>
  (Array.isArray(cohortes) ? cohortes : []).filter((c) => c?.activo !== false);

/**
 * Cohortes para un formulario de EDICIÓN o CONFIRMACIÓN.
 *
 * Devuelve las abiertas MÁS la garantía de que el valor actualmente guardado
 * esté presente, aunque su cohorte esté cerrada o incluso borrada del catálogo.
 *
 * @param {Array}  cohortes     lista cruda devuelta por la API
 * @param {string} valorActual  el texto de cohorte que tiene el registro
 */
export const cohortesParaEdicion = (cohortes, valorActual) => {
  const lista   = Array.isArray(cohortes) ? cohortes : [];
  const actual  = texto(valorActual);
  const activas = cohortesActivas(lista);

  if (!actual) return activas;
  if (activas.some((c) => texto(c?.descripcion) === actual)) return activas;

  const historica = lista.find((c) => texto(c?.descripcion) === actual);

  return [
    ...activas,
    // Si la cohorte ya no está en el catálogo, se sintetiza la opción para que
    // el valor guardado nunca se pierda al abrir el formulario.
    historica ?? { id: `__historica__${actual}`, descripcion: actual, activo: false },
  ];
};
